<template>
  <div v-if="!row[edit]">
    <span class="overflow">{{ propsSingle }}</span>
    <el-button type="text" size="mini" @click="editBtn()">
      <i class="title-icon el-icon-edit"></i>
    </el-button>
  </div>
  <div v-else>
    <el-input
      ref="input"
      v-model.trim="propsSingle"
      class="edit-input"
      size="mini"
      :placeholder="placeholder"
      style="width: 100%"
      @blur="inputBlur()"
      @focus="inputFocus()"
    />
  </div>
</template>

<script>
const numberReg2 = /^([0-9][0-9]*)+(\.[0-9]{1,2})?$/;
const numberReg3 = /^([0-9][0-9]*)+(\.[0-9]{1,3})?$/;
const numberReg100 = /^([1-9]\d{0,1}|100)$/; // 1-100
const numberRegPositive = /^[1-9]\d*$/; // 正整数不包含0
// const pInt = /^\+?[1-9][0-9]*$/;
export default {
  name: 'InnerEditTable',
  props: {
    // 当前行需要编辑的字段
    single: [String, Number],
    // 用于区分同行不同字段点击互不影响
    edit: {
      type: String,
      default: '',
    },
    // 当前行数据
    row: {
      type: Object,
      default() {
        return {};
      },
    },
    // 验证
    verify: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    index: [String, Number],
  },
  data() {
    return {
      // 单项数据流，但这里涉及到input的v-model，不使用sync，这里转一下
      propsSingle: this.single != undefined ? this.single : 0,
      originalSingle: '',
    };
  },
  watch: {
    // 数据改变时为不同的字段增加响应属性
    row(val) {
      this.$set(val, this.edit, false);
    },
    propsSingle(val) {
      this.$emit('update:single', val);
    },
    single(oldVal) {
      this.propsSingle = oldVal;
    },
  },
  created() {
    this.$set(this.row, this.edit, false);
  },
  methods: {
    // 编辑按钮
    editBtn() {
      this.$emit('throttling'); // 为了防抖
      this.row[this.edit] = true;
      this.originalSingle = this.propsSingle;
      this.$nextTick(() => {
        console.log(this.$refs.input);
        this.$refs.input.focus();
      });
    },
    inputFocus() {
      this.$emit('inputFocus');
    },
    inputBlur() {
      this.$emit('throttlingRecovery'); // 为了回复之前的防抖状态
      switch (this.verify) {
        case 'skuStock':
          if (this.propsSingle === '') {
            this.$message.error('请输入库存');
            return false;
          }
          if (
            !numberReg3.test(this.propsSingle) ||
            this.propsSingle <= 0 ||
            this.propsSingle > 1000000
          ) {
            this.$message.error('请输入0-100万的正数，小数点后最多3位');
            return false;
          }
          this.$emit('confirmEdit', this.propsSingle, this.row, this.index);
          break;
        case 'minOrderQuantityk':
          if (this.propsSingle === '') {
            this.$message.error('请输入起订量');
            return false;
          }
          if (
            !numberReg3.test(this.propsSingle) ||
            this.propsSingle <= 0 ||
            this.propsSingle > 1000000
          ) {
            this.$message.error('请输入0-100万的正数，小数点后最多3位');
            return false;
          }
          this.$emit('confirmEdit', this.propsSingle, this.row, this.index);
          break;
        case 'deliverTime':
          if (this.propsSingle === '') {
            this.$message.error('请输入发货周期!');
            return false;
          }
          if (!numberReg100.test(this.propsSingle)) {
            this.$message.error('请输入0-100的正数');
            return false;
          }
          this.$emit('confirmEdit', this.propsSingle, this.row, this.index);
          break;
        case 'price':
          if (this.propsSingle === '') {
            this.$message.error('请输入市场价!');
            return false;
          }
          if (
            !numberReg2.test(this.propsSingle) ||
            this.propsSingle < 0 ||
            this.propsSingle > 1000000000
          ) {
            this.$message.error('请输入0-10亿之间的正数，小数点后最多2位');
            return false;
          }
          this.$emit('confirmEdit', this.propsSingle, this.row, this.index);
          break;
        case 'sortNum':
          if (this.propsSingle === '') {
            this.$message.error('请输入顺序!');
            return false;
          }
          if (!numberRegPositive.test(this.propsSingle)) {
            this.$message.error('请输入正整数');
            return false;
          }
          this.$emit('confirmEdit', this.propsSingle, this.row, this.index);
          break;
      }
      if (this.originalSingle !== this.propsSingle) {
        // 与原始值不相同
        this.$emit(
          'confirmEdit',
          this.propsSingle,
          this.row,
          this.index,
          this.originalSingle
        );
        this.row[this.edit] = false;
      } else {
        this.row[this.edit] = false;
        this.$emit('oladValInputBlur'); // 值未发生改变时input框的失去焦点事件
      }
    },
  },
};
</script>

<style scoped rel="stylesheet/scss" lang="scss">
.overflow {
  display: inline-block;
  max-width: calc(100% - 30px);
  height: 100%;
  line-height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
